exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled-wrapper[data-v-2357437a] {\n  pointer-events: none;\n  opacity: 0.3;\n}\n.format-wrapper[data-v-2357437a] {\n  position: relative;\n  min-height: 64px;\n  overflow: visible;\n}\n@media screen and (max-width: 767.98px) {\n.format-wrapper .format-row[data-v-2357437a] {\n    position: absolute;\n    z-index: 5;\n    left: 0;\n    padding-right: 40px;\n}\n}\n@media screen and (max-width: 767.98px) {\n[data-v-2357437a] .flatpickr-calendar {\n    margin-left: auto;\n    margin-right: auto;\n}\n}", ""]);

// exports
